//require('../styles/ChatApp.css');

import React from 'react';
import io from 'socket.io-client';
import './ChatApp.css';
import Messages from './Messages';
import ChatInput from './ChatInput';

class ChatApp extends React.Component {
  //socket = {};
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
        user_count: 0
    };
    this.sendHandler = this.sendHandler.bind(this);
    this.socket = io('https://imap.brnfngr.de');
    var self = this;

      this.socket.on('connect', function(data) {
      console.log('client connect');
        self.socket.emit('join', 'Hello World from client');
    });

      this.socket.on('new_user', function(data) {
        var data_object = JSON.parse(data);
          self.setState({ messages: data_object.messages });

          self.setState({ user_count: data_object.clients.length });
    });
    this.socket.on('leave_user', function(data) {
        self.setState({ user_count: data });
    });

    // Listen for messages from the server
    this.socket.on('server:message', message => {
      if(this.state.messages.length > 100){
        this.clearMessages(50);
      }
      if(message.username !== this.props.username){
          this.addMessage(message);
      }
    });
  }

  sendHandler(message) {
    const messageObject = {
      username: this.props.username,
      message: message
    };
    // Emit the message to the server
    this.socket.emit('client:message', messageObject);

    messageObject.fromMe = true;
    this.addMessage(messageObject);
  }
    clearMessages(count) {
      const messages = this.state.messages;
      var idx = messages.length - count;
      messages.splice(count,idx);
      this.setState({ messages });
  }

  addMessage(message) {
    // Append the message to the component state
    const messages = this.state.messages;
    messages.push(message);
    this.setState({ messages });
  }

  render() {
    return (
      <div className="container">
        <h3>Tschakkis Chatstube (Online users: {this.state.user_count})</h3>
        <Messages messages={this.state.messages} />
        <ChatInput onSend={this.sendHandler} />
      </div>
    );
  }

}
ChatApp.defaultProps = {
  username: 'Anonymous'
};

export default ChatApp;



// WEBPACK FOOTER //
// ./src/chat/ChatApp.js